// extracted by mini-css-extract-plugin
export default {"layout":"index-module--layout--6fa53","content":"index-module--content--dfae4","form":"index-module--form--ace38"};